import { useContext, useEffect } from 'react';
import WebStepper from 'src/components/Stepper/WebStepper';
import DesktopHeader from 'src/components/util/DesktopHeader';
import MobileHeader from 'src/components/util/MobileHeader';

export default function Page({ children, pageContext }) {
  const { stepNumber, pageTitle } = useContext(pageContext);

  useEffect(() => {
    document.title = pageTitle;
  }, []);

  return (
    <>
      <div className="flex min-h-screen flex-col gap-4">
        <MobileHeader />
        <DesktopHeader />
        <div className="container mx-auto flex flex-grow flex-col p-1">
          <WebStepper stepNumber={stepNumber}>{children}</WebStepper>
        </div>
      </div>
    </>
  );
}
